import { render, staticRenderFns } from "./TextUppercaseIcon.vue?vue&type=template&id=6adeb82e&"
import script from "./TextUppercaseIcon.vue?vue&type=script&lang=js&"
export * from "./TextUppercaseIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports